import React, { memo } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { Button } from "../../../../components/button/Button";
import { Icon } from "../../../../components/icon/Icon";
import { getCSVUrl } from "../../drilldown.selectors";
import { DrilldownRoutePage } from "../../drilldown.types";
import { exportCsv } from "../../../../store/reports/reports.actions";
import { getCSVExportState } from "../../../../store/reports/reports.selectors";
import { CsvExportState } from "../../../../helpers/reports.helper.types";
import { useIntlTranslate } from "../../../../hooks";

const Icons = {
  [CsvExportState.NOT_STARTED]: "fa-regular fa-download color-secondary",
  [CsvExportState.IN_PROGRESS]:
    "fa-regular fa-spin fa-spinner-third color-secondary",
  [CsvExportState.SUCCESS]: "fa-regular fa-check color-secondary",
  [CsvExportState.FAILURE]: "fa-regular fa-xmark color-secondary",
};

const AriaLabels = {
  [CsvExportState.NOT_STARTED]: "aria_export_all_data",
  [CsvExportState.IN_PROGRESS]: "aria_export_all_data_in_progress",
  [CsvExportState.SUCCESS]: "aria_export_all_data_get_success",
  [CsvExportState.FAILURE]: "aria_export_all_data_get_failure",
};

interface Props {
  page: DrilldownRoutePage;
}

function CsvDownloadContent({ page }: Props) {
  const translate = useIntlTranslate();
  const dispatch = useDispatch();

  const href = useSelector(getCSVUrl(page));
  const downloadState = useSelector(getCSVExportState);

  const handleDownloadClick = () => {
    dispatch(exportCsv(href), { showLoader: false });
  };

  return (
    <Button
      onClick={handleDownloadClick}
      color={"secondary"}
      size={"large"}
      aria-live="polite"
      aria-label={translate(AriaLabels[downloadState])}
      disabled={Icons[downloadState] === Icons[CsvExportState.IN_PROGRESS]}
    >
      <Icon icon={Icons[downloadState]} />
      <span>
        <FormattedMessage id={"export_raw_data"} />
      </span>
    </Button>
  );
}

export const CsvDownload = memo(CsvDownloadContent);

CsvDownloadContent.propTypes = {
  page: PropTypes.string.isRequired,
};
